import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "cf3bcbb3-e3d2-4485-b5e5-58f44b64353b",
    options: { imageUrl: `${config.ASSETS_URL}/01/03/task/task-5-chart-1.png` },
  },
  {
    id: "10fbf991-fd62-4c35-a9ed-50be1bbc245e",
    options: { imageUrl: `${config.ASSETS_URL}/01/03/task/task-5-chart-2.png` },
  },
  {
    id: "4ee51b27-6b98-416f-9e14-e5e6dad37d1b",
    options: { imageUrl: `${config.ASSETS_URL}/01/03/task/task-5-chart-3.png` },
  },
  {
    id: "5b846cb9-e5cd-4cb8-8f26-73d1d4014cdc",
    options: { imageUrl: `${config.ASSETS_URL}/01/03/task/task-5-chart-4.png` },
  },
  {
    id: "c404f372-f37c-456e-9b09-276d70ac5cd3",
    options: { imageUrl: `${config.ASSETS_URL}/01/03/task/task-5-chart-5.png` },
  },
  {
    id: "80eb575c-06d3-4d0e-9d8a-19e9559ec2b1",
    options: { imageUrl: `${config.ASSETS_URL}/01/03/task/task-5-chart-6.png` },
  },
  {
    id: "57640f89-27ed-4157-b259-e667705ae36e",
    options: { imageUrl: `${config.ASSETS_URL}/01/03/task/task-5-chart-7.png` },
  },
];

export const task: Task = {
  id: "3b508c07-13af-4269-84ef-a3a0f2ad051a",
  solutionType: "order",
  type: "orderImages",
  options: {
    shuffle: true,
    groupLabelsPosition: "below",
    groupLabels: ["t = 0 s", "t = 4 s", "t = 4.25 s", "t = 4.50 s", "t = 4.75 s", "t = 5.00 s", "t = 9 s"],
    imageSize: 95,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "order",
  data: [
    "cf3bcbb3-e3d2-4485-b5e5-58f44b64353b",
    "10fbf991-fd62-4c35-a9ed-50be1bbc245e",
    "4ee51b27-6b98-416f-9e14-e5e6dad37d1b",
    "5b846cb9-e5cd-4cb8-8f26-73d1d4014cdc",
    "c404f372-f37c-456e-9b09-276d70ac5cd3",
    "80eb575c-06d3-4d0e-9d8a-19e9559ec2b1",
    "57640f89-27ed-4157-b259-e667705ae36e",
  ],
};
